import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useMemo } from "react";
import { useRetailers } from "../../../hooks/useRetailers";

const resolvePlaceholder = (loading, isEmpty, customPlaceholder) => {
  if (loading) return "Loading Retailers...";
  if (isEmpty) return "No Retailers available";
  return customPlaceholder || "Select Retailers";
};

const RetailerSelectComponent = ({
  handleChange,
  label,
  path,
  required,
  visible,
  enabled,
  data,
  uischema,
}) => {
  const { retailers, loading, error } = useRetailers();

  const selected = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return retailers.filter((option) => data.includes(option.id));
  }, [retailers, data]);

  const handleSelectValue = (values) => {
    handleChange(path, Array.isArray(values) ? values.map((value) => value.id) : []);
  };

  if (!visible) return null;

  const isEmpty = !loading && !error && retailers.length === 0;

  const placeholder = resolvePlaceholder(loading, isEmpty, uischema?.placeholder);

  return (
    <div className="multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        childList={retailers}
        selection="multiple"
        isRequired={required}
        label={label}
        disabled={!enabled || loading || !!error || isEmpty}
        selectedValue={selected}
        setSelectedValue={handleSelectValue}
        placeholder={placeholder}
      />
    </div>
  );
};

export const RetailerSelectControl = withJsonFormsMultiEnumProps(
  RetailerSelectComponent
);
